module.exports = __webpack_public_path__ + "img/type1-3.760efd2c.png";